import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Search, Menu, X, Lock } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  ["/", "Início"],
  ["/videos", "Vídeos"],
  ["/fotos", "Fotos"],
  ["/em-alta", "Em alta"],
  ["/mais-curtidos", "Mais curtidos"],
];

export const Header = () => {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    setOpen(false);
    nav(`/videos?q=${encodeURIComponent(q.trim())}`);
  };

  const linkCls = ({ isActive }) =>
    `relative py-1 text-sm tracking-wide transition-colors ${isActive ? "text-white after:absolute after:-bottom-1 after:left-0 after:h-px after:w-full after:bg-rose-500" : "text-slate-300 hover:text-white"}`;

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#08080a]/75 backdrop-blur-xl" data-testid="main-header">
      <div className="mx-auto flex h-20 max-w-[1440px] items-center justify-between gap-6 px-5 sm:px-10">
        <Logo />
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map(([to, l]) => (
            <NavLink key={to} to={to} end={to === "/"} className={linkCls} data-testid={`nav-${l.toLowerCase().replace(/\s/g, "-")}`}>
              {l}
            </NavLink>
          ))}
        </nav>
        <form onSubmit={submit} className="hidden items-center gap-2 border-b border-slate-700 pb-1 focus-within:border-rose-500 md:flex">
          <Search size={15} className="text-slate-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar..." data-testid="header-search-input" className="w-40 bg-transparent text-sm text-white outline-none placeholder:text-slate-500" />
        </form>
        <Link to="/admin" data-testid="header-admin-link" className="hidden items-center gap-2 text-xs uppercase tracking-[0.2em] text-slate-400 transition-colors hover:text-rose-400 lg:flex">
          <Lock size={13} /> Admin
        </Link>
        <button className="text-white lg:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="border-t border-white/5 bg-[#08080a] px-5 pb-8 pt-4 lg:hidden" data-testid="mobile-menu">
          <form onSubmit={submit} className="mb-6 flex items-center gap-2 border-b border-slate-700 pb-2">
            <Search size={16} className="text-slate-400" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar vídeos e fotos" data-testid="mobile-search-input" className="flex-1 bg-transparent text-white outline-none" />
          </form>
          {[...LINKS, ["/admin", "Admin"]].map(([to, l]) => (
            <Link key={to} to={to} onClick={() => setOpen(false)} className="font-serif-d block py-2 text-2xl text-white" data-testid={`mobile-nav-${l.toLowerCase().replace(/\s/g, "-")}`}>
              {l}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
